/**
 * Note about timeout:
 * This timeout includes the time it takes for the user to grant the Location permission.
 * Therefore, if you make it too short (e.g. < 3 seconds) then the request
 * will fail before the user has the chance to click "Allow".
 */
const TIMEOUT = 10000;
const MAX_AGE = 500000;

/**
 *  Returns a promise containing the coordinates of the current location
 *  The coordinates object looks like { latitude, longitude }
 */
export default function fetchCurrentLocation() {
    return new Promise((resolve, reject) => {
        if (typeof navigator === 'undefined' || !('geolocation' in navigator)) { reject(new Error('geolocation api is not enabled')); }

        navigator.geolocation.getCurrentPosition(
            position => resolve(position.coords),
            err => reject(err),
            {
                enableHighAccuracy: true,
                timeout: TIMEOUT,
                maximumAge: MAX_AGE, // keep cached position for 15 minutes
            },
        );
    });
}
